import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  EAccountServiceCode,
  IAdditionalFields,
  IResultPageState,
} from "@common/models";
import { BaseFpxFormComponent } from "@common/base-components";
import { RequestDDHelper, RequestDDState } from "./services/request-dd.helper";
import { REFERENCE_KEY, REQUESTREFERENCE } from "@common/constants";
import { ResultPageService, ResultService } from "@common/services";
import { CommonService } from "src/app/common.service";
import { TranslateService } from "@ngx-translate/core";
import { RetailStock } from "src/app/retail-common.service";
import { ServiceRequestHistoryService } from "src/app/services/service-request-history/service-request-history.service";
import { AccountsService } from "src/app/services/accounts/accounts.service";

@Component({
  selector: "app-request-dd",
  templateUrl: "./request-dd.component.html",
  styleUrls: ["./request-dd.component.scss"],
})
export class RequestDdComponent extends BaseFpxFormComponent<
  RequestDDHelper,
  RequestDDState
> {
  disableMode: boolean;
  requestReference: any;
  constructor(
    _formBuilder: FormBuilder,
    private _router: Router,
    protected requestDdHelper: RequestDDHelper,
    private _resultService : ResultService,
    private _commonService: CommonService,
    protected translate: TranslateService,
    private _retailStock: RetailStock,
    private _serviceRequestHistoryService: ServiceRequestHistoryService,
    private _accountsService: AccountsService
  ) {
    super(_formBuilder, _router, requestDdHelper);
  }

  accType: any = "";

  today = new Date();
  errorType = 'error';


  protected override doPreInit(): void {
    this.requestReference = this._serviceRequestHistoryService.getTrackerDetails()?.requestReference;
    if(this.requestReference) {
      this.disableMode = true;
      this.requestDdHelper.fetchDdDetails(this.requestReference, this.formGroup);
    }
    if(this._commonService.isDesktop()) {
      this._retailStock.backBtnUrl = ['home','transactions'];
      this._retailStock.searchRequired = true;
      this._retailStock.serviceDescription = 'DDREQ.title';
    }
    const accountNumber = this.getRoutingParam(REFERENCE_KEY);
    this.addFormControl("accountNumber", accountNumber, [Validators.required]);
    // this.requestDdHelper.setCurrencyDropDown(accountNumber);

    this.addFormControl("beneName", "", [Validators.required]);
    this.addFormControl("beneId", "", [Validators.required], [], 'change');
    this.addFormControl("issueDate", "", [Validators.required]);
   // this.addFormControl("currency", "", [Validators.required]);
    this.addFormControl("amount", {currencyCode: 'EGP' }, [Validators.required], [], 'change');
    // this.addFormControl("exchangeRate", "", []);
    // this.addFormControl("payableCity", "", [Validators.required], [], "change");
    this.addFormControl("dlvryOption", "", [], [], 'change');
    this.formGroup.controls['dlvryOption'].setValue('1');
    this.addFormControl("dlvryBranch", "", [Validators.required]);
    this.addFormControl("remarks", "", [], [], "change");

    let accDetails = this._accountsService.getAccountSummaryData(accountNumber);
    console.log("Account details are: ", accDetails);
    console.log("Account details Type: ", accDetails.accountType);
    this.accType = accDetails.accountType;
  }

  protected override doPostInit(): void {

  }

  ngOnDestroy(): void {
    this._retailStock.backBtnUrl = undefined;
    this.requestDdHelper.resetState();
  }

  override doConfirm(formGroup: FormGroup) {
    console.log(formGroup.value)
    this.requestDdHelper.doConfirm(
      formGroup.value,
      (res) => {
        this.navigateToResultPage(this._resultService.resultPageData);
      },
      (err) => {
        this.navigateToResultPage(this._resultService.resultPageData);
      }
    );
  }


  submit(): void {
    this.formGroup.disable({ emitEvent: false });
    this._commonService.resetPageScroll(0);
    this.state.disableMode=true;
  }
  edit() {
    this.formGroup.enable({ emitEvent: false });
    this.state.disableMode=false;
  }
  reset() {
    this.formGroup.get('accountNumber').reset();
    this.formGroup.get('beneName').reset();
    this.formGroup.get('beneId').reset();
    this.formGroup.get('issueDate').reset();
    this.formGroup.get('remarks').reset();
   // this.formGroup.get('currency').reset();
    this.formGroup.get('amount').reset();
   // this.formGroup.get('exchangeRate').reset();
    
   // this.formGroup.get('payableState').reset();

  }


}
